import { getPrefixedVar } from '@private/payment';
import styled, { css, keyframes } from 'styled-components';

import { ThemedElement } from 'utils/types';

export const loaderTheme = {
  content: 'palette.primary.20',
};

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export const Container = styled.div<ThemedElement<{ $size: number }>>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ $size }) => `${$size * 0.06}px`};

  ${({ themePrefix = ['components', 'loader'] }) => css`
    & > span {
      background-color: ${getPrefixedVar(themePrefix, 'content')};
    }
  `}
`;

export const Dot = styled.span<{ $delay: string; $size: number }>`
  width: ${({ $size }) => `${$size * 0.19}px`};
  height: ${({ $size }) => `${$size * 0.19}px`};
  border-radius: 50%;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  animation-delay: ${({ $delay }) => $delay};
`;
